
<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card breadcrumb-card">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="d-flex flex-column">
                        <span class="heading">Research Studies Management</span>
                        <span class="sub-heading margin-t-4">Manage all research studies, eligibility, recruiting status, and study metadata.</span>
                    </div>
                    <div>
                        <button class="btn-create" (click)="openModal()"><i class="fa fa-plus"></i> Create Studies</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <div class="row margin-t-40">
                <div class="col-md-9">
                    <ag-grid-angular style="width: 100%;" class="ag-theme-alpine" [theme]="'legacy'"
                        [rowData]="rowData" [columnDefs]="columnDefs" [modules]="modules" [animateRows]="true"
                        [pagination]="pagination" [paginationPageSize]="paginationPageSize" 
                        [paginationPageSizeSelector]="paginationPageSizeSelector" [domLayout]="'autoHeight'" [gridOptions]="gridOptions"
                        rowDragManaged="false" animateRows="true" (gridReady)="onGridReady($event)" [defaultColDef]="{resizable: true, filter: true}" #agGrid>

                    </ag-grid-angular>
                </div>
                <div class="col-md-3">
                    <div class="d-flex justify-content-end">
                        <div class="quick-links-card">
                            <div class="quick-links-title">Quick Links</div>
                            <button class="quick-link-btn mb-2" (click)="openOrganisationModal()">
                                <span><img src="assets/svg/plusIcon.svg"></span> Create Organisation
                            </button>
                            <button class="quick-link-btn mb-2" (click)="openBranchModal()">
                                <span><img src="assets/svg/plusIcon.svg"></span> Create Branch
                            </button>
                            <button class="quick-link-btn" (click)="openUserModal()">
                                <span><img src="assets/svg/plusIcon.svg"></span> Create User
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<confirm-dialog (confirm)="onConfirmDelete()"></confirm-dialog>
<ng-template #cellTemplate let-value="value" let-rowData="rowData">
    <div class="action-container">
        <div class="menu-dropdown">
             <button class="btn menu-btn" type="button" (click)="ViewRow(rowData)"><i class="fa fa-eye"></i></button>
            <button class="btn" type="button" (click)="editRow(rowData)">✏️ </button>
            <button class="btn" type="button" (click)="deleteRow(rowData)">🗑️</button>
        </div>
    </div>
</ng-template>
